/**
 @ngdoc service
 @name mapProjectTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapProjectTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('universalId', 'editURI'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('title'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('orderingManager'));

            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('workingAddress'));
            tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));

            tileFactory.addFieldToColumn3(tileFactory.field.newField('dateOrdered', 'dateTime'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('startDate', 'dateTime'));

            tileFactory.addStatus(tileFactory.status.newCombinedStatus('status', 'secondaryStatus',
                // Positives
                [
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_COMPLETED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_FILLED
                    ]
                ],

                // Negatives
                [
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_REJECTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DISTRIBUTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_PART_FILLED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_CANCELLED
                    ]
                ],
                // Warnings
                [
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_PART_FILLED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DISTRIBUTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_PAUSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DISTRIBUTED
                    ]
                ],
                [
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DRAFT
                    ]
                ]
            ));

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapProjectTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapProjectTileService', mapProjectTileService);
}());
